import type {
  TrackingEvent,
  TrackingPayload,
  YouTubeTrackingPayload,
} from '../types'

const useYouTubeEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackYouTube: (youTubeTracking: YouTubeTrackingPayload) =>
    track('youtube', youTubeTracking),
})

export default useYouTubeEvents
